import styled from "styled-components";

export const FiltersContainer = styled.div`
  background: ${"var(--modal-snow-background-color,var(--snow))"};
  color: var(--color);

  min-height: 42px;
  line-height: 30px;

  display: flex;
  gap: 5px;

  justify-content: start;

  margin-top: 1rem;
  margin-bottom: 1rem;

  border-bottom: 1px solid
    var(--section-color-primary-100-background-color, var(--color-primary-100));
`;
